
import CompareGridLayout from './CompareGridLayout'
import CompareTableLayout from './CompareTableLayout'
import ComparedProducts from '../../graphql/queries/ComparedProducts'

import { get, call } from 'vuex-pathify'

export default {
  name: 'CompareDrawer',
  components: {
    CompareGridLayout,
    CompareTableLayout
  },
  props: {
    layout: {
      type: String,
      default: 'table'
    }
  },
  vessel: {
    clear: {
      textDecoration: 'underline',
      cursor: 'pointer',
      marginLeft: 'xs'
    },
    icon: {
      fontSize: '2xl',
      cursor: 'pointer'
    },
    prev: {
      $extend: 'icon',
      $hasPrev: {
        opacity(value) {
          return value ? 100 : 50
        },
        cursor(value) {
          return value ? 'pointer' : 'default'
        }
      }
    },
    next: {
      $extend: 'icon',
      $hasNext: {
        opacity(value) {
          return value ? 100 : 50
        },
        cursor(value) {
          return value ? 'pointer' : 'default'
        }
      }
    }
  },
  apollo: {
    $client: 'eshop',
    items: {
      query: ComparedProducts,
      variables() {
        return {
          where: { id_in: this.variantIds }
        }
      },
      skip() {
        return !this.visible || this.isEmpty
      },
      update(data) {
        const items = data.products.nodes
        this.updateProducts(items)

        return items
      }
    }
  },
  watch: {
    isEmpty(value) {
      if (value) {
        this.items = null
        this.onClose()
      }
    },
    productsCount(value) {
      if (this.hasPrev && this.skipLimit > value) {
        this.skip = value - this.perPage
      }
    },
    primaryId() {
      this.updateProducts(this.items || [])
    }
  },
  data() {
    return {
      items: null,
      primary: null,
      variants: [],
      attributes: {},
      skip: 0,
      drawer: 'product-compare'
    }
  },
  computed: {
    total: get('productCompare/total'),
    variantIds: get('productCompare/items'),
    primaryId: get('productCompare/primary'),
    tableLayout() {
      return this.layout == 'table'
    },
    layoutComponent() {
      if (this.tableLayout) {
        return this.$screen.match({
          all: 'compare-grid-layout',
          lg: 'compare-table-layout'
        })
      } else {
        return 'compare-grid-layout'
      }
    },
    perPage() {
      if (this.tableLayout) {
        return this.$screen.match({ all: 1, xl: 2 })
      } else {
        return this.$screen.match({ all: 1, md: 2, xl: 3 })
      }
    },
    visible() {
      return this.$drawer.isOpened(this.drawer)
    },
    skipLimit() {
      return this.skip + this.perPage
    },
    isEmpty() {
      return !this.variantIds.length
    },
    productsCount() {
      return this.variantIds.length - 1
    },
    products() {
      return this.variants
        .filter(({ id }) => id != this.primaryId)
        .slice(this.skip, this.skipLimit)
    },
    visibleProducts() {
      if (this.primary) {
        return [this.primary, ...this.products]
      } else {
        return []
      }
    },
    visibleAttributes() {
      const props = {}

      Object.entries(this.attributes).forEach(([id, data]) => {
        props[id] = props[id] || { ...data, values: [] }

        this.visibleProducts.forEach(({ properties }) => {
          const value = properties.reduce((result, prop) => {
            if (prop.propertyId == id) {
              result.push(prop.value)
            }

            return result
          }, [])

          props[id].values.push(value.length ? value : ['--'])
        })
      })

      return Object.values(props)
    },
    hasPrev() {
      return this.skip > 0
    },
    hasNext() {
      return this.skipLimit < this.productsCount
    }
  },
  methods: {
    clear: call('productCompare/clear'),
    updateProducts(items) {
      this.primary = items
        .find(({ id }) => id == this.primaryId)

      this.variants = this.variantIds
        .map(id => items.find(item => item.id == id))
        .filter(item => !!item)

      this.attributes = this.variants.reduce((result, { properties }) => {
        properties.forEach(({ propertyId, name }) => {
          result[propertyId] = { id: propertyId, name }
        })

        return result
      }, {})
    },
    onClose() {
      this.$drawer.close(this.drawer)
    },
    onClear() {
      this.items = null

      this.onClose()
      this.clear()
    },
    onPrev() {
      this.hasPrev && this.skip--
    },
    onNext() {
      this.hasNext && this.skip++
    },
    onSwipePrev() {
      if (this.$screen.touch) {
        this.onPrev()
      }
    },
    onSwipeNext() {
      if (this.$screen.touch) {
        this.onNext()
      }
    }
  }
}
